import { useEffect } from "react";

import { useLocation } from "react-router";

import {
  type SelectedMessageThread,
  selectedThreadId,
  useMessagesStore,
} from "stores/messages";

import SearchParams from "simplydo/core/searchParams";

import api from "api";

import MessageMole from "./MessageMole";
import type { MessageThreadWithAllUsers } from "./types";

type MessageMolesContainerProps = {
  selectedMessageThreads: SelectedMessageThread[];
};

const MessageMolesContainer = ({
  selectedMessageThreads,
}: MessageMolesContainerProps) => {
  const location = useLocation();
  const onMessageThreadSelected = useMessagesStore(
    (state) => state.selectThread,
  );

  useEffect(() => {
    const searchParams = new SearchParams(location.search);
    if (searchParams.has("threadId")) {
      const threadId = searchParams.get("threadId") as string;
      api.messages.getThread(
        threadId,
        ({ thread }) => {
          onMessageThreadSelected(thread);
        },
        () => {},
      );

      // Remove the threadId from the URL after opening
      searchParams.delete("threadId");
      const stringifiedParams = searchParams.toString();
      window.history.replaceState(
        {},
        "",
        location.pathname + (stringifiedParams ? `?${stringifiedParams}` : ""),
      );
    }
  }, [location, onMessageThreadSelected]);

  return (
    <>
      {selectedMessageThreads.map((t, index) => (
        <MessageMole
          thread={t as MessageThreadWithAllUsers}
          index={index}
          key={selectedThreadId(t)}
          totalThreads={selectedMessageThreads.length}
        />
      ))}
    </>
  );
};

export default MessageMolesContainer;
